// @owners { team: patients }
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '~shared/config';

// Shared across every web Stripe Elements provider (legacy Card Element and the new
// Payment Element) so Stripe.js is only ever loaded once, regardless of which flag
// branch actually renders - both modules that mount <Elements/> are statically
// imported from AddPaymentCard.web.tsx, so two separate `loadStripe()` calls at
// module scope would both execute eagerly on load.
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
